<template>
  <img :src="currentSrc" :style="imageStyle" @load="onFullImageLoad" />
</template>

<script>
import { thumbHashToDataURL } from "thumbhash";

export default {
  props: {
    preview: { type: Boolean, default: false },
    src: {
      type: String,
      required: false,
      validator(value, props) {
        return props.preview || !!value;
      },
    },
    thumbhash: { type: String, required: true }, // base64 encoded
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    placeholderSrc() {
      const hash = Uint8Array.from(atob(this.thumbhash), (c) =>
        c.charCodeAt(0)
      );
      return thumbHashToDataURL(hash);
    },
    currentSrc() {
      if (this.preview) {
        return this.placeholderSrc;
      }

      return this.loaded ? this.src : this.placeholderSrc;
    },
    imageStyle() {
      if (this.preview) {
        return null;
      }

      return {
        transition: "filter 0.3s ease",
        filter: this.loaded ? "none" : "blur(4px)",
      };
    },
  },
  methods: {
    onFullImageLoad() {
      this.loaded = true;
    },
  },
  mounted() {
    if (this.preview) {
      return null;
    }

    // Preload full image
    const img = new Image();
    img.onload = () => {
      this.loaded = true;
    };
    img.src = this.src;
  },
  watch: {
    src() {
      this.loaded = false;
      const img = new Image();
      img.onload = () => {
        this.loaded = true;
      };
      img.src = this.src;
    },
  },
};
</script>
